import { FourPointStar } from './enterprise-upsell-svgs';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import FlashOn from '@mui/icons-material/FlashOn';
import PlayArrow from '@mui/icons-material/PlayArrow';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import SettingsSuggestOutlined from '@mui/icons-material/SettingsSuggestOutlined';
import TouchAppOutlined from '@mui/icons-material/TouchAppOutlined';

export default function RulesEngineVideoCardBackground() {
  const theme = useTheme();
  const cardSx = {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    p: 0.5,
    pr: 3,
    borderRadius: 1,
    border: '0.5px solid',
    borderColor: theme.palette.semantic.outline.primary,
    backgroundColor: theme.palette.semantic.surface.bg1,
  };

  const cardIconSx = {
    p: 1,
    borderRadius: 1,
    display: 'flex',
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '-2%',
        left: '80%',
        transform: 'translateX(-50%)',
        width: '565px',
        height: '302px',
        zIndex: 0,
        pointerEvents: 'none',
      }}
    >
      {/* --- BACKGROUND SHAPES (CIRCLES) --- */}
      <Box
        sx={{
          position: 'absolute',
          top: '42%',
          right: '8%',
          width: '222px',
          height: '212px',
          borderRadius: '50%',
          backgroundColor: theme.palette.colors.primary[500],
          opacity: 0.16,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '12%',
          right: '20%',
          width: '234px',
          height: '200px',
          borderRadius: '50%',
          backgroundColor: theme.palette.colors.primary[500],
          opacity: 0.1,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '42%',
          left: '10%',
          width: '332px',
          height: '180px',
          borderRadius: '50%',
          backgroundColor: theme.palette.colors.primary[500],
          opacity: 0.1,
          transform: 'rotate(-5deg)',
        }}
      />

      {/* --- DECORATIONS (Stars & Gears) --- */}
      <FourPointStar size={30} top="18%" left="41%" variant="outlined" />
      <FourPointStar size={18} top="8%" left="53%" variant="outlined" />
      <FourPointStar size={16} top="42%" right="15%" />
      <FourPointStar size={24} top="52%" right="10%" />

      {/* Gears behind Perform Action */}
      <SettingsSuggestOutlined
        sx={{
          position: 'absolute',
          top: '55%',
          left: '4%',
          fontSize: 50,
          color: '#e0e0e0',
          zIndex: 0,
        }}
      />

      {/* Gear behind Automate Rule */}
      <SettingsOutlined
        sx={{
          position: 'absolute',
          top: '17%',
          right: '15%',
          fontSize: 45,
          color: '#e0e0e0',
          zIndex: 0,
        }}
      />

      {/* --- FLOATING BOXES & ARROWS --- */}
      {/* 1. "When condition is met" Box */}
      <Box
        sx={{
          top: '20%',
          left: '-5%',
          ...cardSx,
        }}
      >
        <Box
          sx={{
            bgcolor: theme.palette.semantic.surface.green,
            color: theme.palette.semantic.icon.green,
            ...cardIconSx,
          }}
        >
          <FlashOn fontSize="small" />
        </Box>
        <Typography
          variant="body2"
          sx={{ fontWeight: 500, color: theme.palette.semantic.text.body }}
        >
          When condition is met
        </Typography>
      </Box>

      {/* Arrow from Box 1 to Box 2 */}
      <svg
        style={{ position: 'absolute', top: '38%', left: '1%' }}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M 10 5 Q 10 30 30 30"
          stroke={theme.palette.semantic.icon.accent}
          strokeWidth="4"
          strokeLinecap="round"
          fill="none"
        />
        <polygon
          points="35,30 25,25 25,35"
          fill={theme.palette.semantic.icon.accent}
        />
      </svg>

      <Box
        sx={{
          top: '44%',
          left: '11%',
          ...cardSx,
        }}
      >
        <Box
          sx={{
            bgcolor: theme.palette.semantic.surface.blue,
            color: theme.palette.semantic.icon.blue,
            ...cardIconSx,
          }}
        >
          <TouchAppOutlined fontSize="small" />
        </Box>
        <Typography
          variant="body2"
          sx={{ fontWeight: 500, color: theme.palette.semantic.text.body }}
        >
          Perform an action
        </Typography>
      </Box>

      {/* Arrow from Box 2 to Box 3 */}
      <svg
        style={{ position: 'absolute', top: '43%', left: '47%' }}
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M 10 30 Q 30 30 30 10"
          stroke={theme.palette.semantic.icon.accent}
          strokeWidth="4"
          strokeLinecap="round"
          fill="none"
        />
        <polygon
          points="30,5 25,15 35,15"
          fill={theme.palette.semantic.icon.accent}
        />
      </svg>

      {/* 3. "Automate rule" Box */}
      <Box
        sx={{
          top: '25%',
          right: '20%',
          ...cardSx,
        }}
      >
        <Box
          sx={{
            bgcolor: theme.palette.semantic.surface.violet,
            color: theme.palette.semantic.icon.violet,
            ...cardIconSx,
          }}
        >
          <PlayArrow fontSize="small" />
        </Box>
        <Typography
          variant="body2"
          sx={{ fontWeight: 500, color: theme.palette.semantic.text.body }}
        >
          Automate rule
        </Typography>
      </Box>
    </Box>
  );
}
